import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../providers/AuthProvider";
import { Spin } from "antd";

interface ProtectedRouteProps {
    children: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return <Spin size="large" tip="Loading..." />;
    }

    if (!isAuthenticated) {
        // Redirect to login page but save the location they were trying to access
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};
